import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { InvalidTransactionIdPopoverComponent } from './invalid-transaction-id-popover.component'

@Injectable()
export class InvalidTransactionIdPopoverService {
  constructor(private readonly modalService: NgbModal) {}

  toggle(transactionIds: string[] | number[]): Promise<string> {
    const modalRef = this.modalService.open(
      InvalidTransactionIdPopoverComponent,
      {
        size: 'md',
        keyboard: false,
      },
    )
    modalRef.componentInstance.transactionIds = transactionIds
    return modalRef.result
  }
}
